/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDealerInfo_seller$ref = any;
export type PdpSharedDealerInfo_seller = {
    readonly agreementStart: string | null;
    readonly shippingAddress: {
        readonly displayCityStateCountry: string | null;
    } | null;
    readonly analytics?: {
        readonly metrics: {
            readonly responseTime: {
                readonly value: number | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": PdpSharedDealerInfo_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDealerInfo_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isClient",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "agreementStart",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "shippingAddress",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayCityStateCountry",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isClient",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "analytics",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MCAnalytics",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "metrics",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MCAnalyticsMetrics",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "responseTime",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MCMetricResponseTime",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "value",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'f8955598431568c6c3817631de25d4a7';
export default node;
